var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiCameraIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 79,
    viewBox: "0 0 80 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C21.6569 0 23 1.34315 23 3C23 4.65685 21.6569 6 20 6H7V19C7 20.6569 5.65685 22 4 22C2.34315 22 1 20.6569 1 19V3C1 1.34315 2.34315 1.85283e-07 4 0H20Z",
    fill: "#322C4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61 0C59.3431 0 58 1.34315 58 3C58 4.65685 59.3431 6 61 6H74V19C74 20.6569 75.3431 22 77 22C78.6569 22 80 20.6569 80 19V3C80 1.34315 78.6569 1.85283e-07 77 0H61Z",
    fill: "#322C4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 79C21.6569 79 23 77.6569 23 76C23 74.3431 21.6569 73 20 73H6V60C6 58.3431 4.65685 57 3 57C1.34315 57 -5.95338e-08 58.3431 0 60V76C7.24234e-08 77.6569 1.34315 79 3 79C3.17033 79 3.33742 78.9863 3.5 78.959C3.66258 78.9863 3.82967 79 4 79H20Z",
    fill: "#322C4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61 79C59.3431 79 58 77.6569 58 76C58 74.3431 59.3431 73 61 73H74V60C74 58.3431 75.3431 57 77 57C78.6569 57 80 58.3431 80 60V76C80 77.6569 78.6569 79 77 79H61Z",
    fill: "#322C4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1932 56H16.125L27.9034 21.0909H39.1364L50.9148 56H41.8466L33.6477 29.8864H33.375L25.1932 56ZM23.983 42.2614H42.9375V48.6705H23.983V42.2614ZM63.1108 21.0909V56H54.6733V21.0909H63.1108Z",
    fill: "#322C4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiCameraIcon);
export default __webpack_public_path__ + "static/media/aiCameraIcon.f9d447c986c9f3493b5df754d471cc1a.svg";
export { ForwardRef as ReactComponent };